export default "__VITE_ASSET__nq_xMUC9__"